import { eCurrencies } from "app/common/ui/info-icon/info-icon.interface"
import { eContracts } from "../contract/contract.config"

export interface ICompanyItemsResponse {
    id: eCompanyItems
    title: string
    shortDescription: string
    isNFTBound: boolean
    items?: string[]
    idOnchain: string
    contract: eContracts
    craft?: ICraft[]
    prices: IPrices[]
    dollarPrice: number
    candyPrice: string
    image?: string
}

export interface ICraft {

    id: string//"toy-boost-1",
    level: number
    name: string//"TOY BOOST I",
    boost: string// "10%",
    burnItems: IBurnItem[]
}

export interface IPrices {
    price: string,
    currency: {
        name: string
        symbol: eCurrencies
        address: string
    }
}

export interface IBurnItem {
    image: string
    itemUpgradeId: string
    itemUpgradeName: string
    name: string
    mainItemTypeId: string
    resultItemTypeId: string
    resultItemName: string
    quantity: number
}

export enum eCompanyItems {
    LOOTBOX_BASIC = 'LOOTBOX_BASIC',
    LOOTBOX_MEDIUM = 'LOOTBOX_MEDIUM',
    LOOTBOX_PREMIUM = 'LOOTBOX_PREMIUM',
    UNFREEZE_POTION = 'UNFREEZE_POTION',
    DIAMOND_STORY_CHEST = 'DIAMOND_STORY_CHEST',
    BATTLE_STAMINA_POTION = 'BATTLE_STAMINA_POTION',
    BATTLE_STAMINA_POTIONX5 = 'BATTLE_STAMINA_POTION-5',
    TOY_TOKEN = 'TOY-BOOST-TOKEN',
    TRAINING_TOKEN = 'TRAINING-BOOST-TOKEN',
    FOOD_TOKEN = 'FOOD-BOOST-TOKEN',
    HEALTH_TOKEN = 'HEALTH-BOOST-TOKEN',
    REFORGING_ANVIL = 'REFORGING-ANVIL',
    BATTLE_LEAGUE_PASS = 'BATTLE_LEAGUE_PASS'
}

export const companyItemImgPath = (): { [key in eCompanyItems]: string } => {
    return {
        [eCompanyItems.LOOTBOX_BASIC]: './assets/img/Icon/lootbox-bronze.png',
        [eCompanyItems.LOOTBOX_MEDIUM]: './assets/img/Icon/lootbox-silver.png',
        [eCompanyItems.LOOTBOX_PREMIUM]: './assets/img/Icon/lootbox-gold.png',
        [eCompanyItems.DIAMOND_STORY_CHEST]: './assets/img/Icon/lootbox-diamond.png',
        [eCompanyItems.UNFREEZE_POTION]: './assets/img/Icon/unfreeze-potion.png',
        [eCompanyItems.BATTLE_STAMINA_POTION]: './assets/img/Icon/battle_stamina_potion.png',
        [eCompanyItems.BATTLE_STAMINA_POTIONX5]: './assets/img/Icon/battle_stamina_potion.png',
        [eCompanyItems.TOY_TOKEN]: './assets/img/nftItems/toy-boost-token.png',
        [eCompanyItems.TRAINING_TOKEN]: './assets/img/nftItems/training-boost-token.png',
        [eCompanyItems.FOOD_TOKEN]: './assets/img/nftItems/food-boost-token.png',
        [eCompanyItems.HEALTH_TOKEN]: './assets/img/nftItems/health-boost-token.png',
        [eCompanyItems.REFORGING_ANVIL]: './assets/img/nftItems/Reforging Anvil.png',
        [eCompanyItems.BATTLE_LEAGUE_PASS]: './assets/img/nftItems/BATTLE_LEAGUE_PASS.png',
    }
}

//TODO
export const getCurrencyContract = (currency: eCurrencies): eContracts => {
    let currenciesContract: { [key in eCurrencies]: eContracts } = {
        [eCurrencies.KMON]: eContracts.KMON,
        [eCurrencies.CANDIES]: eContracts.KMON,
        [eCurrencies.BabyDoge]: eContracts.BabyDoge,
        [eCurrencies.BNB]: eContracts.KMON, //TODO
        [eCurrencies.POINTS]: eContracts.KMON, //TODO
        [eCurrencies.USDT]: eContracts.USDT,
        [eCurrencies.CreditCard]: null
    };
    return currenciesContract[currency];
}

export const getSimilarProduct = (item: eCompanyItems): Partial<eCompanyItems>[] => {
    //its not possible to have same item in more than 1 list

    let allItems: Partial<eCompanyItems>[][] = [
        [
            eCompanyItems.LOOTBOX_BASIC,
            eCompanyItems.LOOTBOX_MEDIUM,
            eCompanyItems.LOOTBOX_PREMIUM,
            eCompanyItems.DIAMOND_STORY_CHEST,
            eCompanyItems.UNFREEZE_POTION,
            eCompanyItems.BATTLE_STAMINA_POTION,
            eCompanyItems.BATTLE_STAMINA_POTIONX5
        ],
        [
            eCompanyItems.TOY_TOKEN,
            eCompanyItems.TRAINING_TOKEN,
            eCompanyItems.FOOD_TOKEN,
            eCompanyItems.HEALTH_TOKEN
        ]

    ];
    let oIndex: { typeIndex: number, indexItemToRemove: number }; //typeIndex is 0 for lootboxItems and 1 for craftItems, indexItemToRemove is the index of item to remove
    allItems.forEach((type, typeIndex) => {
        let itemIndex = type.findIndex(i => i == item);
        if (itemIndex != -1) oIndex = { typeIndex: typeIndex, indexItemToRemove: itemIndex };
    });
    if (oIndex) {
        allItems[oIndex.typeIndex].splice(oIndex.indexItemToRemove, 1);
        return allItems[oIndex.typeIndex];
    } else return []
}
